import { gql } from '@apollo/client';
import Fragments from './fragments';
import CommonFragments from 'features/common/fragments';

export const ACCOUNT_STATEMENT_UPDATED = gql`
  subscription accountStatementUpdated {
    accountStatementUpdated {
      accountStatement {
        ...accountStatementItem
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${Fragments.accountStatementItem}
  ${CommonFragments.messageHeaders}
`;
export const ACCOUNT_STATEMENT_DETAIL_DELETED = gql`
  subscription accountStatementDetailDeleted {
    accountStatementDetailDeleted {
      configDetailId
    }
  }
`;

export const ACCOUNT_STATEMENT_DETAIL_UPDATED = gql`
  subscription accountStatementDetailUpdated {
    accountStatementDetailUpdated {
      accountStatementDetail {
        ...accountStatementDetailItem
      }
      isNew
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
  ${Fragments.accountStatementDetailItem}
`;

export const ACCOUNT_STATEMENT_INDICATOR_DELETED = gql`
  subscription accountStatementIndicatorDeleted {
    accountStatementIndicatorDeleted {
      statementIndicatorId
    }
  }
`;

export const ACCOUNT_STATEMENT_INDICATOR_UPDATED = gql`
  subscription accountStatementIndicatorUpdated {
    accountStatementIndicatorUpdated {
      accountStatementIndicator {
        ...accountStatementIndicatorItem
      }
      headers {
        ...messageHeaders
      }
    }
  }

  ${CommonFragments.messageHeaders}
  ${Fragments.accountStatementIndicatorItem}
`;

export const ACCOUNT_STATEMENT_DUPLICATED = gql`
  subscription accountStatementDuplicated {
    accountStatementDuplicated {
      configId
    }
  }
`;
